import Home from "../../pages/home";

export const routeGantt = "/gantt";
export const routeHome = "/home";

export const ganttRoutes = [
	{
		path: routeGantt,
		element: <Home />,
	},
	{
		path: routeHome,
		element: <Home />,
	},
];
